import { render, staticRenderFns } from "./standardsectionimport.vue?vue&type=template&id=338eaffb"
import script from "./standardsectionimport.vue?vue&type=script&lang=js"
export * from "./standardsectionimport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports